var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-aperture 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 8C10.7656 8 0 18.7656 0 32C0 45.2344 10.7656 56 24 56C37.2344 56 48 45.2344 48 32C48 18.7656 37.2344 8 24 8ZM24 12C26.0938 12 28.1016 12.2812 30 12.875V23.875L18.8125 12.6875C20.4688 12.2422 22.2031 12 24 12ZM14.75 14.25L22.5 22H6.6875C8.59375 18.6953 11.3594 16.0078 14.75 14.25ZM34 14.6875C37.2891 16.5859 39.9297 19.4453 41.6875 22.8125L34 30.5V14.6875ZM4.875 26H15.875L4.6875 37.1875C4.25 35.5391 4 33.7891 4 32C4 29.9062 4.28125 27.8984 4.875 26ZM21.5 26H26.5L30 29.5V34.5L26.5 38H21.5L18 34.5V29.5L21.5 26ZM43.3125 26.8125C43.75 28.4609 44 30.2109 44 32C44 34.0938 43.7188 36.1016 43.125 38H32.125L43.3125 26.8125ZM14 33.5V49.3125C10.7109 47.4141 8.07031 44.5547 6.3125 41.1875L14 33.5ZM18 40.125L29.1875 51.3125C27.5312 51.7578 25.7969 52 24 52C21.9062 52 19.8984 51.7188 18 51.125V40.125ZM25.5 42H41.3125C39.4062 45.3047 36.6406 47.9922 33.25 49.75L25.5 42Z",
    fill: "#005BFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroExperience);
export default __webpack_public_path__ + "static/media/heroExperience.b844baad316e1b5dac7d69c8f5ea019c.svg";
export { ForwardRef as ReactComponent };